import {
	ApplicationConfig,
	importProvidersFrom,
	inject,
	provideAppInitializer,
	provideZoneChangeDetection
} from "@angular/core";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { jwtInterceptor } from "./shared/interceptors/jwt/jwt.interceptor";
import { responseInterceptor } from "./shared/interceptors/response/response.interceptor";
import { providePrimeNG } from "primeng/config";
import { onetagPreset } from "./styles/onetag-preset";
import { provideRouter, withNavigationErrorHandler } from "@angular/router";
import { routes } from "./app.routes";
import { ConfirmationService, MessageService } from "primeng/api";
import { ConsoleProxyService } from "./shared/services/console-proxy/console-proxy.service";
import { registerLocaleData } from "@angular/common";
import localeEn from "@angular/common/locales/en";
import localeIt from "@angular/common/locales/it";
import localeFr from "@angular/common/locales/fr";
import { JwtModule } from "@auth0/angular-jwt";
import { reloadOnChunkLoadError } from "./shared/core/router/chunk-load-error.handler";

registerLocaleData(localeEn);
registerLocaleData(localeIt);
registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		MessageService,
		ConfirmationService,
		importProvidersFrom(JwtModule.forRoot({})),
		provideAppInitializer(() => {
			inject(ConsoleProxyService);
		}),
		provideHttpClient(withInterceptors([jwtInterceptor, responseInterceptor])),
		provideRouter(routes, withNavigationErrorHandler(reloadOnChunkLoadError)),
		providePrimeNG({
			overlayAppendTo: "body",
			theme: {
				preset: onetagPreset,
				options: {
					darkModeSelector: false,
					cssLayer: {
						name: "primeng",
						order: "tailwind-base, primeng, tailwind-utilities"
					}
				}
			}
		})
	]
};
